module.exports = __webpack_public_path__ + "img/loginLogo.40ecaba6.png";